import React from 'react'

const BigLoader = () => {
  return (
    <div className="w-20 h-20 border-4 border-primary border-l-transparent rounded-full animate-spin"></div>
  );
}

export default BigLoader